import utils from './utils.js';
import app from './app.js';

const IMAGE_MAX_SIZE = 1024 * 1024 * 5
const IMAGE_ALLOW_TYPE = ['jpg', 'jpeg', 'png', 'bmp']//, 'tiff', 'tif', 'webp'

export const UploadFile = function() {
	this.file = ''
	this.ratio = 1
	this.image = ''
	this.base64 = ''
}

/**
 * 上传
 */
UploadFile.prototype.upload = function(file, success, error) {
	if(file===null){
		$('.edit_box .load').hide();
		$('.edit_box>.uploadBox').show();
		return false
	}
	let rs = this.checkImage(file)
	if(!rs){
		$('.edit_box .load').hide();
		$('.edit_box>.uploadBox').show();
		return false
	}

	let _this = this
	this.file = file

	let fileReader  = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = function () {
    	utils.loadImage(this.result, img => {
			// 打点，选择文件-分辨率
			app.manage('select_file_resolving_power',img.width+'x'+img.height);

    		_this.image = img
			_this.base64 = this.result
			if (success) 
				$('.edit_box .load').hide();
				$('.image-loading-box').hide();
				$('.alert-mask').hide();
				// 最大限制4k
				if(img.width>4096 || img.height>4096){
					showMessageBox('error',i18nWaterMark.global.t('watermark_beyond_4k'))
					if(!app.first){
						app.manage('lloading_fail_first','resolving_power')
					}else{
						app.manage('loading_fail','resolving_power');
					}
					$('.edit_box .load').hide();
					$('.edit_box>.uploadBox').show();
					return false;
				}
				// 大于用户limit的值
				if(img.width>app.subscriptions[0].benefits[1].limit || img.height>app.subscriptions[0].benefits[1].limit){
					showMessageBox('error',i18nWaterMark.global.t('watermark_beyond_pixel_1').replace(/%s/g,app.subscriptions[0].benefits[1].limit))
					if(!app.first){
						app.manage('lloading_fail_first','resolving_power')
					}else{
						app.manage('loading_fail','resolving_power');
					}
					$('.edit_box .load').hide();
					$('.edit_box>.uploadBox').show();
					return false;
				}
				if(app.subscriptions[0].product_feature<1){
					if(!user){
						if(img.width>app.subscriptions[0].benefits[1].threshold || img.height>app.subscriptions[0].benefits[1].threshold){
							if(app.subscriptions[0].benefits[1].quota-app.subscriptions[0].benefits[1].usage<=0){
								$('.maskRights').show();
								$('.maskRightsBox').show().siblings().hide();
								$('.maskRightsBox .tip').html(i18nWaterMark.global.t('watermark_beyond_pixel_3').replace(/%s/g,app.subscriptions[0].benefits[1].threshold));
								$('.maskRightsBox .tip_btn .upgrade_btn').show().siblings().hide()
								app.manage('trigger_rights','resolving_power');
								$('.edit_box .load').hide();
								$('.edit_box>.uploadBox').show();
								return false;
							}
						}
					}
				}
				if(!app.first){
					app.manage('loading_success_first','')
				}else{
					app.manage('loading_success','');
				}
				success(img)
    	}, err => {
    		if (error)
    			error(err)
				if(!app.first){
					app.manage('lloading_fail_first','99')
				}else{
					app.manage('loading_fail','99');
				}
				$('.edit_box .load').hide();
				$('.edit_box>.uploadBox').show();
    			showMessageBox('error', i18nWaterMark.global.t('watermark_remove_image_type_error'))
    	})
    };
    fileReader.onerror = function() {
		$('.edit_box .load').hide();
		$('.edit_box>.uploadBox').show();
        showMessageBox('error', i18nWaterMark.global.t('watermark_remove_image_type_error'))
    };
	
	
}

UploadFile.prototype.changeImage = function(img) {
	this.image = img
}

UploadFile.prototype.changeBase64 = function(base64) {
	this.base64 = base64
}

/**
 * 检测图片格式和尺寸
 */
UploadFile.prototype.checkImage = function(file) {
	if (!file) {
		showMessageBox('error', i18nWaterMark.global.t('watermark_remove_file_type_error'))
		$('.edit_box .load').hide();
		$('.edit_box>.uploadBox').show();
     	return false
	}

	// 打点，选择文件-文件大小
	app.manage('select_file_size',file.size)
	
	// 检测图片尺寸
	if (file.size > app.subscriptions[0].benefits[0].limit*1) {
		if(user){
			showMessageBox('error',i18nWaterMark.global.t('watermark_beyond_size_1').replace('%s',app.subscriptions[0].benefits[0].limit/1024/1024))
		}else{
			$('.maskRights').show();
			$('.maskRightsBox').show().siblings().hide();
			var mb=app.subscriptions[0].benefits[0].limit/1024/1024
			$('.maskRightsBox .tip').html(i18nWaterMark.global.t('watermark_beyond_size_3').replace(/%s/g,mb));
			$('.maskRightsBox .tip_btn .upgrade_btn').show().siblings().hide()
			app.manage('trigger_rights','size');
			return false
		}
		if(!app.first){
			app.manage('loading_fail_first','size')
		}else{
			app.manage('loading_fail','size');
		}
		$('.edit_box .load').hide();
		$('.edit_box>.uploadBox').show();
		return false;
	}
	if(app.subscriptions[0].benefits[0].quota!=-1){
		if (file.size > app.subscriptions[0].benefits[0].threshold) {
			if(app.subscriptions[0].benefits[0].quota-app.subscriptions[0].benefits[0].usage<=0){
				$('.maskRights').show();
				$('.maskRightsBox').show().siblings().hide();
				$('.maskRightsBox .tip').html(i18nWaterMark.global.t('watermark_beyond_size_3').replace('%s',app.subscriptions[0].benefits[0].threshold/1024/1024));
				$('.maskRightsTips .down_info').hide();
				$('.maskRightsTips .box .down').hide();
				$('.maskRightsBox .tip_btn .upgrade_btn').show().siblings().hide()
				app.manage('trigger_rights','size');
				return false
			}
		}
	}
	if(app.subscriptions[0].product_feature<1){
		if (file.size > app.subscriptions[0].benefits[0].limit*1) {
			if(app.subscriptions[0].benefits[0].quota-app.subscriptions[0].benefits[0].usage<=0){
				$('.maskRights').show();
				$('.maskRightsBox').show().siblings().hide();
				var mb=app.subscriptions[0].benefits[0].limit/1024/1024
				$('.maskRightsBox .tip').html(i18nWaterMark.global.t('watermark_beyond_size_3').replace(/%s/g,mb));
				$('.maskRightsBox .tip_btn .upgrade_btn').show().siblings().hide()
				app.manage('trigger_rights','size');
				$('.edit_box .load').hide();
				$('.edit_box>.uploadBox').show();
				return false
			}
		}
	}
	// 检测文件类型是否为图片
	if( (file.type).indexOf("image/") == -1 ){  
     	showMessageBox('error', i18nWaterMark.global.t('watermark_remove_file_type_error')) 
		$('.banner_box>div .btn span').removeClass('load');
		if(!app.first){
			app.manage('lloading_fail_first','type')
		}else{
			app.manage('loading_fail','type');
		}
		$('.edit_box .load').hide();
		$('.edit_box>.uploadBox').show();
     	return false
    }  

	// 检测图片类型
	var imgType = file.type.split('/')[1]
	var typeError = 1;
	for(let item of IMAGE_ALLOW_TYPE) {
		if (imgType.indexOf(item) != -1) {
			typeError = 0;
			break
		}
	}
	// 打点，选择文件-格式
	app.manage('select_file_format',imgType)

	/*if (! IMAGE_ALLOW_TYPE.includes(imgType)) {
		alert(file.type)
		alert(imgType)
		showMessageBox('error', i18nWaterMark.global.t('watermark_remove_image_type_error'))
		return false
	}*/
	if (typeError) {
		showMessageBox('error', i18nWaterMark.global.t('watermark_remove_image_type_error'))
		$('.edit_box .load').hide();
		if(!app.first){
			app.manage('lloading_fail_first','type')
		}else{
			app.manage('loading_fail','type');
		}
		$('.edit_box .load').hide();
		$('.edit_box>.uploadBox').show();
		return false
	}
	return true
}

/**
 * 计算图片应显示尺寸比例
 * 以操作台宽高的的90%为最大值
 */
UploadFile.prototype.imageShowSizeRatio = function(img) {
	let workStationWidth = document.querySelector('.edit_box').offsetWidth
	let workStationHeight = document.querySelector('.edit_box').offsetHeight
	let widthRatio = (workStationWidth * 0.9) /  img.width 
	let HeightRatio = (workStationHeight * 0.9) / img.height

	let minRatio = Math.min(widthRatio, HeightRatio)
	this.ratio = minRatio
	app.zoom.setScale(minRatio)
	if (minRatio < 0.2 ) {
		if (minRatio > 0.05)
			app.zoom.setMinScale(minRatio - 0.05)
		else 
			app.zoom.setMinScale(minRatio)
	}
}

/**
 * 显示上传提示框
 */
function showMessageBox(type, text='') {
	window.scrollTo(0,0)
	$('.photo').removeClass('active');
	$('.mask').css({
		'display': 'block',
		'z-index': 2
	})
	$('.image-loading-box').show()
	$('.show-message-box').hide()
	document.body.style.overflow = 'hidden'
	switch(type) {
		case 'warning': 
			$('.load-warning-box').show()
			$('.warning-text').html(text)
			break
		case 'error':
			console.log(2)
			$('.load-error-box').show()
			$('.error-text').html(text)
			if($('.photo').css('display')=='flex'){
				$('.alert-mask').css({
					'display': 'block',
					'z-index': 5
				})
			}
			break
		case 'loading':
			$('.loading-box').show()
			$('.loading-icon').html('10%')
			break
	}
	
	$('.confirm').off()
    $('.cancel').off()
	$('.confirm').click(function() {
		$('.image-loading-box').hide()
		$('.alert-mask').hide()
	})
	$('.cancel').click(function() {
		$('.image-loading-box').hide()
		$('.alert-mask').hide();
		if (typeof cancel == 'function')
			cancel()
	})
}
